import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { createPortal } from 'react-dom';
import Draggable from 'react-draggable';

import { useTranslation } from '@gem/modules/i18n';
import { VideoPlayer } from '@gem/ui-kit';

import { useGlobalVideoPlayerPresenter } from './GlobalVideoPlayer.presenter';
import styles from './GlobalVideoPlayer.styles.m.css';

const PREVENT_DRAG_SELECTORS = 'button, [role="progressbar"]';

export const GlobalVideoPlayer = observer(() => {
  const presenter = useGlobalVideoPlayerPresenter();
  const { t } = useTranslation();

  const containerClass = classNames(styles.container, {
    [styles.mini]: presenter.isMini,
    [styles.hidden]: presenter.isHidden,
  });

  if (!presenter.url) {
    return null;
  }

  return createPortal(
    <Draggable
      cancel={PREVENT_DRAG_SELECTORS}
      bounds={'body'}
      disabled={!presenter.isDraggable}
      position={!presenter.isDraggable ? { x: 0, y: 0 } : presenter.position}
      onStop={presenter.onDragEnd}
    >
      <div className={containerClass}>
        <VideoPlayer
          url={presenter.url}
          previewUrl={presenter.previewUrl}
          autoPlay={true}
          isPlaying={presenter.isPlaying}
          isFullScreenMode={presenter.isFullScreenMode}
          type={presenter.type}
          playerConfig={presenter.playerConfig}
          onTogglePlay={presenter.onTogglePlay}
          onToggleFullScreenMode={presenter.onToggleFullScreenMode}
          onConfigUpdate={presenter.setPlayerConfig}
          onShowMiniPlayer={presenter.canShowMiniPlayer ? presenter.onShowMiniPlayer : undefined}
          onExpandMiniPlayer={
            presenter.canExpandMiniPlayer ? presenter.onExpandMiniPlayer : undefined
          }
          onCloseMiniPlayer={presenter.onCloseMiniPlayer}
          normalSpeedText={t('common_normal')}
        />
      </div>
    </Draggable>,
    presenter.container
  );
});
